module.exports = __webpack_public_path__ + "static/media/profesional-services.2e56d658.svg";